<template>
  <div>
    <b-form @submit.stop.prevent="formOnsubmit">
      <!-- Name input -->
      <b-form-group
        id="input-group-name"
        label="Nama:"
        label-for="input-name"
      >
        <b-form-input
          id="input-name"
          v-model="form.name"
          placeholder="Nama Ruangan"
        ></b-form-input>
        <small class="text-danger">{{ error.name }}</small>
      </b-form-group>

      <!-- Floor Input -->
      <b-form-group
        id="input-group-floor"
        label="Lantai:"
        label-for="input-floor"
      >
        <b-form-input
          id="input-floor"
          v-model="form.floor"
          placeholder="Lantai Ruangan"
        ></b-form-input>
        <small class="text-danger">{{ error.floor }}</small>
      </b-form-group>

      <!-- Building Input -->
      <b-form-group
        id="input-group-building"
        label="Gedung:"
        label-for="input-building"
      >
        <treeselect
          :multiple="false"
          :options="buildings"
          placeholder="Pilih Gedung"
          v-model="form.building_id"
        />
        <small class="text-danger">{{ error.building_id }}</small>
      </b-form-group>

      <!-- Description input -->
      <b-form-group id="input-group-description">
        <label for="input-description">Deskripsi: <em class="text-muted">opsional</em></label>
        <b-form-textarea
          id="input-description"
          v-model="form.description"
          placeholder="Deksripsi Ruangan"
          rows="4"
          max-rows="8"
        ></b-form-textarea>
        <small class="text-danger">{{ error.description }}</small>
      </b-form-group>

      <!-- Submit & Cancel button -->
      <b-button
        type="submit"
        variant="primary"
      >Simpan</b-button>
      <b-button
        type="button"
        class="ml-2"
        variant="default"
        @click="$router.push('/masters/rooms')"
      >
        Batal
      </b-button>
    </b-form>
  </div>
</template>

<script>
import module from "@/core/modules/CrudModule.js";
import validation from "@/core/modules/ValidationModule.js";
import "@riophae/vue-treeselect/dist/vue-treeselect.css"

export default {
  props: {
    form: Object,
    route: String,
  },

  data() {
    return {
      // Error
      error: {
        name: "",
        building_id: "",
        building_name: "",
        floor: "",
        description: "",
      },
      buildings: [],
    };
  },

  methods: {
    // async getPolyclinics() {
    //   let response = await module.setSelectOption('polyclinics')
    //   if (response.state == 'success') {
    //     this.polyclinics = response.data
    //     this.polyclinics.push({ text: "Pilih Poliklinik", value: null, disabled: true })
    //   }
    // },

    async getBuildingOptions() {
      let response = await module.setTreeSelect("buildings")
      // Success
      if (response.state == "success") {
        // Set Option Select
        this.buildings = response.data
        this.buildings.unshift({ label: "Pilih Gedung", id: "", isDisabled: true, })
      }
    },

    async formOnsubmit() {
      // Make Request
      let response = await module.submit(this.form, this.route);
      // Check Response
      if (response.state == "error") {
        // Validation Error
        this.error = validation.setValidationError(
          this.error,
          response.error.errors
        );
      } else {
        // Success
        Swal.fire(response.success.title, response.success.message, "success");
        this.$router.push("/masters/rooms");
      }
    },
  },
  mounted() {
    this.getBuildingOptions()
  }
};
</script>

<style>
</style>